// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.artwork-preview-surface {
  --artwork-preview-max-height: 220px;
  align-items: center;
  background-color: #767676;
  border: 1px solid rgba(30, 41, 59, 0.18);
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
  display: inline-flex;
  justify-content: center;
  max-height: var(--artwork-preview-max-height);
  max-width: 100%;
  overflow: hidden;
  padding: 12px;
}

.artwork-preview-surface__image {
  display: block;
  filter: drop-shadow(0 1px 1px rgba(15, 23, 42, 0.55)) drop-shadow(0 -1px 1px rgba(255, 255, 255, 0.65));
  height: auto;
  max-height: calc(var(--artwork-preview-max-height) - 24px);
  max-width: 100%;
  object-fit: contain;
  width: auto;
}

.artwork-preview-surface--overlay-option {
  margin-bottom: 10px;
}

.artwork-preview-surface--selected-artwork {
  margin-bottom: 20px;
}

.artwork-preview-surface--proof-preview {
  display: flex;
  margin: 0 auto;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Shop/DigitalProofingForms/ArtworkPreviewSurface.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,4CAA4C;EAC5C,oBAAoB;EACpB,uBAAuB;EACvB,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,uGAAuG;EACvG,YAAY;EACZ,0DAA0D;EAC1D,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;AACb","sourcesContent":[".artwork-preview-surface {\n  --artwork-preview-max-height: 220px;\n  align-items: center;\n  background-color: #767676;\n  border: 1px solid rgba(30, 41, 59, 0.18);\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n  display: inline-flex;\n  justify-content: center;\n  max-height: var(--artwork-preview-max-height);\n  max-width: 100%;\n  overflow: hidden;\n  padding: 12px;\n}\n\n.artwork-preview-surface__image {\n  display: block;\n  filter: drop-shadow(0 1px 1px rgba(15, 23, 42, 0.55)) drop-shadow(0 -1px 1px rgba(255, 255, 255, 0.65));\n  height: auto;\n  max-height: calc(var(--artwork-preview-max-height) - 24px);\n  max-width: 100%;\n  object-fit: contain;\n  width: auto;\n}\n\n.artwork-preview-surface--overlay-option {\n  margin-bottom: 10px;\n}\n\n.artwork-preview-surface--selected-artwork {\n  margin-bottom: 20px;\n}\n\n.artwork-preview-surface--proof-preview {\n  display: flex;\n  margin: 0 auto;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
